import BPButton from 'components/BionicUI/button/BPButton';
import BPContainer from 'components/BionicUI/container/BPContainer';
import BPLinkButton from 'components/BionicUI/linkButton/BPLinkButton';
import BPPopup from 'components/BionicUI/popup/BPPopup';
import { useEffect, useState } from 'react';
import { OnboardingEye } from '../Eye';
import DisplayApplicationData from './DisplayApplicationData';
import InputBar from '../InputBar';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from './OnboardingSequence';
import { useNavigate } from 'react-router-dom';
import { PostUserSubmitApplicationRequest } from 'core/models/users/submit/post-user-submit-application.model';
import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
import { ROUTES } from 'routes';
import { useAuth } from 'context/auth.context';
import useOnboardingStore from 'stores/onboardingStore';

const ReviewYourApplication = () => {
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const [showReviewPopup, setShowReviewPopup] = useState<boolean>(false);
  const navigate = useNavigate();
  const { handleProfileCreationOrLoad } = useAuth();
  const { setProgressStep } = useOnboardingStore();

  async function handleSubmit(): Promise<void> {
    setShowReviewPopup(false);
    try {
      const request: PostUserSubmitApplicationRequest = {};
      await new UserV1BaseServerRepo().submitApplication(request);
      await handleProfileCreationOrLoad();
      navigate(ROUTES.APPLICATION_IN_REVIEW);
    } catch (error) {}
  }

  useEffect(() => {
    setTimeout(() => setShowInputBar(true), 1500);
  }, []);

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          // line1={{
          //   text: "Congratulations! You've reached the final step.",
          //   sound: 'step1/congratulations-reached-final-step_1.mp3',
          // }}
          line1={{
            text: 'After submitting this step, your account will be created and you can complete the application.',
            sound: 'step1/after-submitting-this-step.mp3',
          }}
        />
      </div>
      {showInputBar && (
        <InputBar onClickBackButton={() => setProgressStep(5)}>
          <BPContainer twWidth="w-auto md:w-[644px] justify-normal">
            <BPButton state="primary" onClick={handleSubmit}>
              Submit
            </BPButton>
          </BPContainer>
          <BPLinkButton
            className="text-[12px]"
            onClick={() => setShowReviewPopup(true)}
          >
            Review your application
          </BPLinkButton>
        </InputBar>
      )}
      {showReviewPopup && (
        <BPPopup widthLimit={800} handleClose={() => setShowReviewPopup(false)}>
          <DisplayApplicationData handleSubmit={handleSubmit} />
        </BPPopup>
      )}
    </SequenceItem>
  );
};

export default ReviewYourApplication;
